import { useContext, useEffect } from 'react'
import { Grid, Typography, useMediaQuery } from '@material-ui/core' // Srini 07-01-25
import { withStyles } from '@material-ui/core/styles'
import styles from './headerStyles'
import { reducerContext } from '../../../contextApi\'s/contextApi\'s'


const AgentStatus = ({ classes }) => {
    const { state, dispatch } = useContext(reducerContext)
    const isSmallScreen = useMediaQuery('(max-width: 600px)') // Srini 07-01-25
    const { tokenValid, sipStatus } = state

    const userName = localStorage.getItem('username')
    const userId = localStorage.getItem('user_id1')
    const departmentName = localStorage.getItem('departmentName')
    const roleName = localStorage.getItem('roleName') // srini - 31/12/24
    // Dev Srini 25/10/24
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (sipStatus) {
                // window.sipUnRegister()
                console.log("SIP unregistered successfully on Refresh.")

                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: 'Unregistered successfully.' })

                const message = 'Are you sure you want to leave ?'
                event.returnValue = message
                return message
            }
        }

        if (sipStatus) {
            window.addEventListener('beforeunload', handleBeforeUnload)
        }

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [sipStatus])

    return (
        // rewritten - Srini 07-01-25
        <Grid  style={{ display: 'flex', alignItems: 'center' }}>
            <Grid item xs={isSmallScreen ? 4 : 1.5}>
                <div className={classes.logoContainer}>
                    <a href="/incomplete-kyc" className={classes.dashboardLink}>
                        <img
                            src="ui-assests/images/TradeBossLogo.png"
                            alt="logo"
                            className={classes.logo}
                        />
                    </a>
                    {/* <Typography className={classes.vrsnTxt}>
                        (Ver 1.1.2e) 
                    </Typography> */}
                </div>
            </Grid>
            {tokenValid === 'Valid' && (
                <Grid item xs={isSmallScreen ? 8 : 9}>
                    <div className={classes.userDetailsContainer}>
                        <Typography className={classes.agentStatusText}>
                            Agent Name:
                        </Typography>
                        <Typography
                            className={classes.agentStatusText}
                            style={{ marginLeft: '7px', }}
                        >
                            {userName} - {userId} - {departmentName} - {roleName}
                        </Typography>
                    </div>
                </Grid>
            )}
        </Grid>
    );

}

export default withStyles(styles)(AgentStatus)